module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background_cn.dd44a9b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background_cn.jpg
// module id = 3014
// module chunks = 11